import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AccountLogoFetchFailedAction = {
	type: 'ACCOUNT_LOGO_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AccountLogoFetchFailedAction => ({
	type: 'ACCOUNT_LOGO_FETCH_FAILED',
	payload,
});
